export default __webpack_public_path__ + "static/media/complete.fe769aff.svg";